import * as angular from 'angular';
import GobActivity from "../../models/activity/gobActivity";
import {MachineActivity, SectionActivity, ShopActivity} from "../../models/activity/shopActivity";
import HourActivity from "../../models/activity/hourActivity";
import NotifyServiceName, {NotifyService} from "../../services/notify/notify.service";
import LoaderServiceName, {LoaderService} from "../../components/loader/loader.service";
import JobChangeServiceName, {JobChangeService} from "../../services/jobChange/jobChange.service";
import DateUtilityService, {DateTimeRange} from "../../services/utility/dateutility.service";
import UIUtilityServiceName, {EnumOption, UIUtilityService} from "../../services/utility/uiUtility.service";
import {apsEnums} from "../../shared/dto/aps.enums";
import {apsCommands} from "../../shared/dto/aps.commands";
import * as _ from "lodash";
import template from './addJobChange.tpl.html';

let requires = [NotifyServiceName, LoaderServiceName, JobChangeServiceName, UIUtilityServiceName];

export default angular.module('aps.controller.addJobChange', requires)
  .controller('AddJobChangeCtrl', addJobChangeCtrl)
  .name;

export interface AddJobChangeData {
  gob: GobActivity;
  shopId: string;
  activity: ShopActivity;
  hour: HourActivity;
}

export function openAddJobChange(data: AddJobChangeData,
                                 $modal: mm.foundation.modal): angular.IPromise<any> {
  return $modal.open({
    template: template,
    controller: 'AddJobChangeCtrl as vm',
    resolve: {
      data: function() {
        return data;
      }
    }
  }).result;
}

interface AddJobChangeController {
  addJobChange(): void;
  cancel(): void;
  validateMoldNumbers(): boolean;
  displaySectionsGobsAndMolds(): boolean;
  addJobChangeCommand: apsCommands.AddJobChange;
  selections: SectionSelection[];
  jobChangeTypes: EnumOption[];
  timeChanged: Date;
  range: DateTimeRange;
  gobs: GobActivity[];
  sections: SectionActivity[];
  machine: MachineActivity;
  section: SectionActivity;
  timeZone: string;
  activity: ShopActivity;
  shopId: string;
  gob: GobActivity;
  form: angular.IFormController;
}

interface SectionSelection {
  section: SectionActivity;
  gobs: GobSelection[];
}

interface GobSelection {
  gob: GobActivity;
  currentMold: string;
}

function addJobChangeCtrl(
  $modalInstance: mm.foundation.modalInstance,
  data: AddJobChangeData,
  notifyService: NotifyService,
  loaderService: LoaderService,
  jobChangeService: JobChangeService,
  uiUtilityService: UIUtilityService
) {

  'use strict';
  let vm = this as AddJobChangeController;

  vm.gob = data.gob;
  vm.shopId = data.shopId;
  vm.activity = data.activity;
  vm.timeZone = vm.activity.timeZoneId;

  vm.section = vm.gob.section;
  vm.machine = vm.section.machine;
  vm.sections = vm.machine.sections;
  vm.gobs = _.first(vm.sections).gobs;

  vm.range = DateUtilityService.getHourRange(data.hour.startTime, vm.timeZone);
  vm.timeChanged = vm.range.initialTime.toDate();

  vm.jobChangeTypes = uiUtilityService.getListOptionsFromEnum(apsEnums.JobChangeType, 1);

  vm.selections = [];

  vm.addJobChangeCommand = {
    shopId: vm.shopId,
    isMachineId: vm.machine.id,
    jobRunId: data.hour.jobRun.id,
    type: undefined,
    endTime: vm.timeChanged,
    duration: undefined,
    details: []
  };

  vm.displaySectionsGobsAndMolds = function() {
    return !vm.addJobChangeCommand.type ||
      vm.addJobChangeCommand.type !== apsEnums.JobChangeType.Finish;
  };

  vm.validateMoldNumbers = function() {

    if (!vm.displaySectionsGobsAndMolds()) {
      return true;
    }

    let moldNumbers = [];
    _.forEach(vm.selections, function(selection: any) {
      _.forEach(selection.gobs, function(gobSelection: any) {
        moldNumbers.push({ moldNumber: gobSelection.moldNumber });
      });
    });
    return _.uniq(_.map(moldNumbers, x => JSON.stringify(x))).length === moldNumbers.length;
  };

  _.forEach(vm.sections, (section) => {

    let sectionSelection = {
      section: section,
      gobs: []
    };

    _.forEach(section.gobs, (gob) => {
      sectionSelection.gobs.push({
        gob: gob,
        currentMold: ''
      });
    });

    vm.selections.push(sectionSelection);
  });

  let fillJobChangeDetails = function() {
    vm.addJobChangeCommand.details = [];

    if (!vm.displaySectionsGobsAndMolds()) {
      return;
    }

    _.forEach(vm.selections, function(selection: any) {
      let section = selection.section.sectionNumber;
      _.forEach(selection.gobs, function(gobSelection: any) {
        let gob = gobSelection.gob.gobNumber;

        if (section > 0 || gob > 0) {
          vm.addJobChangeCommand.details.push({
              section: section,
              gob: gob,
              moldNumber: gobSelection.moldNumber
          });
        }
      });
    });
  };

  vm.addJobChange = function() {
    if (vm.form.$invalid || vm.validateMoldNumbers() === false) {
      return false;
    }

    fillJobChangeDetails();

    let promise = jobChangeService.addJobChange(vm.addJobChangeCommand)
      .then(function() {
        $modalInstance.close(true);
      }, notifyService.handleApiErrors);
    loaderService.loadingPromise(promise);
  };

  vm.cancel = function() {
    $modalInstance.close();
  };
}


// WEBPACK FOOTER //
// ./src/app/controllers/jobChange/addJobChange.controller.ts